import React from 'react';
import { Component, NavigationActions, SettingsActions, SettingsStore } from '../../../client';
import BreadCrumbs from '../../../components/navigation/BreadCrumbs';
import { Page, PageContent, PageHeader } from '../../../components/ux/Page';
import PriorityEditor from '../../../components/issues/PriorityEditor';
import Typography from '@material-ui/core/Typography';

class Priorities extends Component {
   constructor(props) {
      super(props);

      this.stores = [SettingsStore];
      this.listenables = [SettingsActions];

      this.storekeys = ['priorities', 'priorityReorderSaving', 'priorityReorderError'];

      this._onAddPriorityRequested = this._onAddPriorityRequested.bind(this);
      this._onDeletePriorityRequested = this._onDeletePriorityRequested.bind(this);
      this._onUpdatePriorityRequested = this._onUpdatePriorityRequested.bind(this);
      this._onReorderPrioritiesRequested = this._onReorderPrioritiesRequested.bind(this);
   }

   _onAdminClicked() {
      NavigationActions.to({ to: '/app/account' });
   }

   _onAddPriorityRequested({ name, color, resolutionTargetMins }) {
      SettingsActions.addPriority({ name, color, resolutionTargetMins });
   }

   _onDeletePriorityRequested({ no }) {
      SettingsActions.deletePriority({ noPriority: no });
   }

   _onUpdatePriorityRequested({ no, name, color, resolutionTargetMins }) {
      SettingsActions.updatePriority({ noPriority: no, name, color, resolutionTargetMins });
   }

   _onReorderPrioritiesRequested({ orderedPriorityNos }) {
      return SettingsActions.reorderPriorities({ orderedPriorityNos });
   }

   render() {
      const crumbs = [{ name: 'Admin', onClick: this._onAdminClicked }];
      const { priorities, priorityReorderSaving, priorityReorderError } = this.state;

      return (
         <div className='app-wrapper Priorities'>
            <BreadCrumbs crumbs={crumbs} />
            <Page>
               <PageHeader title={'Change Priorities'} bar={true} />

               <PageContent margin={'wide'}>
                  <Typography variant='body1'>Priorities help communicate the urgency of issues. Some examples are 'P1' or 'Urgent'.</Typography>
                  <br />
                  <Typography variant='body1'>
                     <b>Note:</b>&nbsp;Deletions and resolution-target changes do not recalculate existing Issue deadlines. Renaming affects
                     existing Issues, while additions and target changes apply to future calculations and explicit resets.
                  </Typography>
                  <PriorityEditor
                     priorities={priorities}
                     onAddRequested={this._onAddPriorityRequested}
                     onDeleteRequested={this._onDeletePriorityRequested}
                     onUpdateRequested={this._onUpdatePriorityRequested}
                     onReorderRequested={this._onReorderPrioritiesRequested}
                     reorderSaving={priorityReorderSaving}
                     reorderError={priorityReorderError}
                  />
               </PageContent>
            </Page>
         </div>
      );
   }
}

export default Priorities;
